import React, { Component, useState, useEffect } from "react";
import {
  login,
  page,
  ContentDetails,
  RelatedContent,
  GetPlayurl,
} from "../../Model/Content"; //Include Home
import { getGeoInfo, userprofile } from "../../Model/Users";
import { isMobile } from "react-device-detect";
import { Bannerplayer } from "../../components/vidjs/mainPlayer";
import VideoPlayer from "react-awesome-player";
import videojs from "video.js";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import Slider from "react-slick";
import videojsqualityselector from "videojs-hls-quality-selector";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import BarLoader from "react-spinners/BarLoader";
import { withRouter } from "react-router";
import {
  BrowserRouter as Router,
  Routes,
  useParams,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { SVGIcons, ImgIcons, VirsionCheck, Appsflyer, branchIO } from "../../Helpers/Common";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

var options = {};
function onVideoPlay(player) { }
function onPlayerReady(player) {
  var player = videojs("my-player");
  var options = {};

  var player = videojs("my-player", options, function onPlayerReady() {
    videojs.log("Your player is ready!");
    this.play();
    this.on("ended", function () {
      videojs.log("Awww...over so soon?!");
    });
  });

  var videojs = require("video.js");

  require("videojs-hls-quality-selector");

  var player = videojs("my-video");

  player.hlsQualitySelector({
    displayCurrentQuality: true,
  });

  return player;
}

export function Playcontent(props) {
  var player = {};
  const playerRef = React.useRef();
  const [contentdata, setContent] = useState(0);
  const [dataloaded, setDataloaded] = useState(0);
  const [RelatedContentdata, setRelatedcontent] = useState(0);
  const [PlayURLbtn, setPlayURLbtn] = useState(0);
  const [PlayURLbtndata, setPlayURLbtndata] = useState(0);
  const [MainDetailsp, setMainDetailsp] = useState(true);
  const [subscribeduser, setsubscribeduser] = useState(false);
  const [showmodel, setshowmodel] = useState(undefined);
  const [contentID, setContentId] = useState();
  const { content_slug } = useParams();
  const navigate = useNavigate();
  /*---------------*/
  const getData = () => {

    getGeoInfo().then((res) => {
      ContentDetails(content_slug, res).then((res) => {
        let data = {
          seesionID: localStorage.getItem("session_id"),
          userID: localStorage.getItem("userID")
        }

        userprofile(data).then((res) => {
          var userdata = JSON.parse(res.data.message);
          if (userdata.success == false) {
            navigate("/createaccount");
          }
          if (userdata.user_data.subscriptions) {
            if (userdata.user_data.grace_period) {
              setsubscribeduser(true)
            }
            if (userdata.user_data.is_subscribed) {
              setsubscribeduser(true)
            }
          }
        })

        if (res.data.message && res.data.message == "session_expired") {
          navigate("/createaccount");
        }

        var content_details = JSON.parse(res.data);
        // Appsflyer("Watch Trailer Viewed", { "Title": content_details.content?.title, "Contentid": content_details.content?.ID })
        // branchIO("Watch Trailer Viewed", { "Title": content_details.content?.title, "Contentid": content_details.content?.ID })
        // if (content_details.content?.ID) {
        var extractedNumber
        var numbers = content_slug.match(/\d+/g);

        if (numbers !== null) {
          extractedNumber = numbers.join('');
          // setContentId(extractedNumber)
        } else {
          console.log("No data found.");
        }

        var Postdata = {
          content_id: content_details.content.ID,
          content_type: content_details.content.content_type,
          seesionID: localStorage.getItem("session_id"),
          userID: localStorage.getItem("userID")
        };

        GetPlayurl(Postdata).then((PlayURLresponse) => {
          setPlayURLbtndata(PlayURLresponse);
          setContent(content_details);
          if (PlayURLresponse) {
            if (PlayURLresponse.data.subtitles) {
              content = PlayURLresponse.data;
            }
            var videoURL = PlayURLbtndata;
            if (videoURL.statusCode == "403") {
              return <p>No content found</p>;
            }
            setDataloaded(true);
            var content = videoURL.content;
          }
        });

        // } else {
        //   setDataloaded(false);
        // }
      });
    })
  };
  /*---------------*/
  useEffect(() => {

    getData();
  }, []);

  function Showmodels() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
    setshowmodel(true);
  }
  function Closemodel() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
    setshowmodel(false);
  }
  function PlayURL(content_id, content_type) {
    setMainDetailsp(false);
    setPlayURLbtn(true);

  }

  function closePlayer() {

    window.history.go(-1)
  }

  if (PlayURLbtn) {

    if (PlayURLbtndata.data.subtitles) {
      var content = PlayURLbtndata.data;

      var subtitles = [];
      if (content.subtitles) {
        if (content.subtitles.length > 0) {
          for (var i in content.subtitles) {
            var tempObj = {};
            tempObj["srclang"] = content.subtitles[i]['lang'];
            tempObj["label"] = content.subtitles[i]['lang'];
            tempObj["src"] = content.subtitles[i]['file'];
            subtitles.push(tempObj);
          }
        }
      }
    }

  }

  if (dataloaded == false) {
    // return <div className="loader"></div>;
    return <div className="loader"><BarLoader color="#ff000f" /></div>;
  } else {

    if (contentdata.show_details) {
      var contentdata1 = contentdata?.show_details;
      var contentid = contentdata.content?.ID;
      var contents = contentdata?.content;

    } else {
      var contentdata1 = contentdata?.content;
      var contentid = contentdata.content?.ID;
      var contents = contentdata?.content;

    }
    var Today = new Date();
    var Releasing_Date = new Date(contentdata1?.publish_start_date).getTime();
    Today = new Date(Today).getTime();
    if (Releasing_Date > Today) {
      window.history.go(-1)
    }

    return (

      <>
        {/* <Helmet>
          <title>DocuBay-{contentdata1?.title}</title>
          <meta name="description" content="" />
          <meta name="keywords" content={contentdata1?.genres} />
          <meta property="og:title" content="" />
        </Helmet> */}
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 5 }}
          key="1"
        >
          <Bannerplayer data={PlayURLbtndata.data.url?.video_url}
            subtitles={PlayURLbtndata.data.subtitles}
            message={PlayURLbtndata.data.cautionary_messages}
            post={contentdata1?.banner_image?.medium}
            functionclose={closePlayer}
            autoPlay={true}
            subscribed={subscribeduser}
            showmodel={Showmodels}
            content_details={contentdata1}
            content_id={contentid}
            contentdata={contents}
          />
        </motion.div>
      </>

    )
  }

}
